<template>
    <div>
        <div class="mb-3">
            <your-vehicle
                v-if="registration != null"
                :registration="registration"
                :make="make"
                :model="model"
                :image-base-path="imageBaseUrl"
                :postcode="postcode"
                :size-options="sizeOptions"
            ></your-vehicle>
            <fitter-filters
                :filters="filters"
                :has-reviews="hasReviews"
                :page="page"
                :postcode="filters.postcode"
                :fitters-shown="fittersShown"
                @update-filters="updateFilters"
                @submit="getFitters"
            ></fitter-filters>
        </div>
        <div class="row mb-3">
            <div id="fitters-column" class="col-12 col-lg-5 fitters-column" :style="fittersHeight">
                <template v-if="hasSearched && (postcode || filters.postcode) && (!updatedSortedFitters || updatedSortedFitters.length === 0)">
                    <p>There are no fitters available that match your selection.</p>
                    <p>Please use the filters above to change your search, or use the button below to increase your search radius.</p>
                    <button type="button" class="btn btn-primary" @click="manuallyIncreaseSearchRadius()">Increase search distance</button>
                </template>
                <div class="row">
                    <fitter
                        v-for="fitter in updatedSortedFitters"
                        :fitter="fitter"
                        :key="fitter.id"
                        :route="route"
                        :mobile-fitting-slots="mobileFittingSlots"
                        :view="view"
                        v-bind:ref="el => setFitterRef(el, fitter.id)"
                    ></fitter>
                </div>
				<div class="text-center col-12" v-if="canLoadMoreFitters">
					<button class="fitter-page-load-more btn btn-primary" type="button" @click="loadMoreFitters()">
						Load 10 more fitters
					</button>
				</div>
            </div>
            <div class="col-12 col-lg-7 d-none d-lg-block">
                <fitter-map
                    v-if="updatedSortedFitters && updatedSortedFitters.length > 0"
                    :fitters="updatedSortedFitters"
                    :google-maps-api-key="googleMapsApiKey"
                    :postcode-details="this.updatedPostcodeDetails"
                    :view="view"
                ></fitter-map>
            </div>
        </div>
    </div>
</template>

<script>
    import fitters from '@shared/mixins/fitters';

    export default {
        props: [
            'sortedFitters',
            'distance',
            'sortBy',
            'fitterTypes',
            'limit',
            'page',
            'postcode',
            'fitters',
            'mobileFitters',
            'chooseFitterFilters',
            'fitterResultsLimit',
            'hasReviews',
            'googleMapsApiKey',
            'postcodeDetails',
            'route',
            'mobileFittingSlots',
            'view',
            'mobileFitterRoute',
            'mountedSearch',
            'imageBaseUrl',
            'registration',
            'make',
            'model',
            'sizeOptions'
        ],
        mixins: [fitters],
        data() {
            return {
                // store component refs by fitter id to avoid using dynamic string refs
                fitterRefs: {}
            };
        },
        mounted() {
			//removes loading placeholder - fixes CLS issue
			document.querySelector('#loadingPlaceholder').style.display = 'none';
        },
        methods: {
            setFitterRef(el, id) {
                // ref callback: store or remove element by id
                if (el) {
                    this.fitterRefs[id] = el;
                } else {
                    delete this.fitterRefs[id];
                }
            },
            //overriding mixin function for custom map markers
            sortMapIcons(val) {
            if (!val) return false;
            
            let vm = this;
            const path = (this.baseUrl ? this.baseUrl : '') + '/assets/icons/';
            const ext = '.png';

            let garageFitters = val.filter((fitter) => {
                return fitter.mobile == 0;
            });

            let i = 1;

            _.forEach(garageFitters, function(fitter, index) {
                fitter['mapIconNumber'] = ((vm.view == 'fitters' || vm.view == 'fittedNationally') ? _toStr(i) : '.');
                fitter['mapIconSymbol'] = path + ((vm.view == 'fitters' || vm.view == 'fittedNationally') ? 'fitter' : 'tyre') + ext;
                fitter['mapIconColour'] = 'white';

                if(fitter.cal_account_number == 'CALFIT' || fitter.featured == true) {
                    fitter['mapIconSymbol'] = path + ((vm.view == 'fitters' || vm.view == 'fittedNationally') ? 'protyre' : 'tyre') + ext;
                }

                i++;
            });
        }
        },
        computed: {
            canLoadMoreFitters() {
                if (!this.updatedSortedFitters || this.updatedSortedFitters.length === 0) return false;

                const result = this.updatedSortedFitters.length % this.filters.limit;

                if (result !== 0) {
                    return false;
                }

                return true;
            },
            fittersHeight() {
                return (this.updatedSortedFitters && this.updatedSortedFitters.length > 0) ? 'height: 80vh' : '';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .fitters-column {
        @media screen and (max-width: 991px) {
            height: auto !important;
        }
        @media screen and (min-width: 992px) {
            overflow-x: scroll;
        }
    }
</style>